export default "__VITE_ASSET__DccyzSkN__"